import { useEffect, useState } from "react";
// import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { Routes, Route, useLocation } from "react-router-dom";
import { CurrencyProvider } from "./Context/CurrencyContext";
import { usePromo } from "./Context/PromoContext";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import PromoSaleCountDown from "./Components/PromoSaleCountDown";
import Home from "./Pages/Index";
import Contact from "./Pages/Contact";
import CaseStudies from "./Pages/CaseStudies";
import CaseStudyDetail from "./Pages/CaseStudyDetails";
import Disclaimer from "./Pages/Legal/Disclaimer";
import PrivacyPolicy from "./Pages/Legal/PrivacyPolicy";
import RefundPolicy from "./Pages/Legal/RefundPolicy";
import TermsAndConditions from "./Pages/Legal/TermsAndConditions";
import CloudHosting from "./Pages/Hosting/CloudHosting";
import LinuxHosting from "./Pages/Hosting/LinuxHosting";
import LinuxResellerHosting from "./Pages/Hosting/LinuxResellerHosting";
import WordpressHosting from "./Pages/Hosting/WordpressHosting";
import LinuxCloudVPS from "./Pages/VPS/LinuxCloudVPS";
import WindowsCloudVPS from "./Pages/VPS/WindowsCloudVPS";
import ManagedLinuxVPS from "./Pages/VPS/ManagedLinuxVPS";
import UnmanagedLinuxVPS from "./Pages/VPS/UnmanagedLinuxVPS";
import DedicatedServerNewYork from "./Pages/Dedicated/DedicatedServerNewYork";
import DedicatedServerLosAngeles from "./Pages/Dedicated/DedicatedServerLosAngeles";
import DedicatedServerMontreal from "./Pages/Dedicated/DedicatedServerMontreal";
import DedicatedServerBrazil from "./Pages/Dedicated/DedicatedServerBrazil";
import DedicatedServerGermany from "./Pages/Dedicated/DedicatedServerGermany";
import DedicatedServerIndia from "./Pages/Dedicated/DedicatedServerIndia";
import DedicatedServerSingapore from "./Pages/Dedicated/DedicatedServerSingapore";
import DedicatedServerUAE from "./Pages/Dedicated/DedicatedServerUAE";
import StreamingServers from "./Pages/Streaming/StreamingServers";
import LiveStreamingVOD from "./Pages/Streaming/LiveStreamingVOD";
import StreamingServerNewYork from "./Pages/Streaming/StreamingServerNewYork";
import StreamingServerLosAngeles from "./Pages/Streaming/StreamingServerLosAngeles";
import StreamingServerMontreal from "./Pages/Streaming/StreamingServerMontreal";
import StreamingServerLondon from "./Pages/Streaming/StreamingServerLondon";
import Office365 from "./Pages/Email-and-Security/Office365";
import CyberSecurity from "./Pages/Email-and-Security/CyberSecurity";
import Zimbra from "./Pages/Email-and-Security/Zimbra";
import SSL from "./Pages/Email-and-Security/SSL";
import GPUDedicatedServerGermany from "./Pages/GPU/GPUDedicatedServerGermany";
import GPUDedicatedServerUK from "./Pages/GPU/GPUDedicatedServerUK";
import GPUDedicatedServerFrance from "./Pages/GPU/GPUDedicatedServerFrance";
import GPUDedicatedServerNetherlands from "./Pages/GPU/GPUDedicatedServerNetherlands";
import GPUDedicatedServerSweden from "./Pages/GPU/GPUDedicatedServerSweden";
import GPUDedicatedServerSwitzerland from "./Pages/GPU/GPUDedicatedServerSwitzerland";
import GPUDedicatedServerIreland from "./Pages/GPU/GPUDedicatedServerIreland";
import GPUCloudServerIndia from "./Pages/GPU/GPUCloudServerIndia";
import GPUDedicatedServerUSA from "./Pages/GPU/GPUDedicatedServerUSA";
import ServerManagement from "./Pages/Solutions/ServerManagement";
import WebDevelopment from "./Pages/Solutions/WebDevelopment";
import AppDevelopment from "./Pages/Solutions/AppDevelopment";
import DigitalMarkeing from "./Pages/Solutions/DigitalMarketing";
import AiChatbot from "./Pages/Solutions/AiChatbot";
import RAG from "./Pages/Solutions/RAG";
import AiSoftwareService from "./Pages/Solutions/AiSoftwareService";
import BackupSolutions from "./Pages/Solutions/BackupSolutions";
import About from "./Pages/Company/About";
import FAQs from "./Pages/Company/FAQs";
import OurTeam from "./Pages/Company/OurTeam";
import Deals from "./Pages/Company/Deals";
import AwardsAndRecognitions from "./Pages/Company/AwardsAndRecognitions";
import Certificate from "./Pages/Company/Certificate";
import PaymentOptions from "./Pages/Company/PaymentOptions";
import WorkCulture from "./Pages/Company/WorkCulture";
import AWS from "./Pages/Platforms/AWS";
import Azure from "./Pages/Platforms/Azure";
import GoogleCloud from "./Pages/Platforms/GoogleCloud";
import Kubernetes from "./Pages/Platforms/Kubernetes";
import Odoo from "./Pages/Platforms/Odoo";
import VtigerSolutions from "./Pages/Platforms/VtigerSolutions";
import TawkInfinitive from "./Components/TawkInfinitive";
import Hotjar from "./Components/Hotjar";
import SiteMap from "./Pages/SiteMap";

import NotFound from "./Pages/404";
import "./App.css";

function DefaultLayout({ children }) {
  const location = useLocation();
  const { promoMessages, loading } = usePromo();
  const [showPromo, setShowPromo] = useState(false);
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

    useEffect(() => {
      if (!isClient || loading) return;

      const currentPage = location.pathname.replace("/", "");

      const matched = promoMessages.find(
        (item) => item.pageName === currentPage
      );

      setShowPromo(!!matched);
    }, [location.pathname, promoMessages, loading, isClient]);

  return (
    <>
      <Header />
      {children}
      <PromoSaleCountDown showPromo={showPromo} />
      <Footer />
      {isClient && <TawkInfinitive />}
      {isClient && <Hotjar />}
    </>
  );
}

function App() {
  return (
    <>
      <div className="main-wrapper">
        <main>
        <CurrencyProvider>
          <Routes>
            <Route path="/" element={ <DefaultLayout> <Home /> </DefaultLayout> } />
            <Route path="/about-us" element={ <DefaultLayout> <About /> </DefaultLayout> } />
            <Route path="/frequently-asked-questions" element={ <DefaultLayout> <FAQs /> </DefaultLayout> } />
            <Route path="/contact-us" element={ <DefaultLayout> <Contact /> </DefaultLayout> } />
            <Route path="/case-studies" element={ <DefaultLayout> <CaseStudies /> </DefaultLayout> } />
            <Route path="/case-study/:slug" element={ <DefaultLayout> <CaseStudyDetail /> </DefaultLayout> } />
            <Route path="/disclaimer" element={ <DefaultLayout> <Disclaimer /> </DefaultLayout> } />
            <Route path="/privacy-policy" element={ <DefaultLayout> <PrivacyPolicy /> </DefaultLayout> } />
            <Route path="/refund-policy" element={ <DefaultLayout> <RefundPolicy /> </DefaultLayout> } />
            <Route path="/terms-and-conditions" element={ <DefaultLayout> <TermsAndConditions /> </DefaultLayout> } />
            <Route path="/cloud-hosting" element={ <DefaultLayout> <CloudHosting /> </DefaultLayout> } />
            <Route path="/linux-hosting" element={ <DefaultLayout> <LinuxHosting /> </DefaultLayout> } />
            <Route path="/linux-reseller-hosting" element={ <DefaultLayout> <LinuxResellerHosting /> </DefaultLayout> } />
            <Route path="/wordpress-hosting" element={ <DefaultLayout> <WordpressHosting /> </DefaultLayout> } />
            <Route path="/linux-cloud-vps" element={ <DefaultLayout> <LinuxCloudVPS /> </DefaultLayout> } />
            <Route path="/windows-cloud-vps" element={ <DefaultLayout> <WindowsCloudVPS /> </DefaultLayout> } />
            <Route path="/managed-linux-vps" element={ <DefaultLayout> <ManagedLinuxVPS /> </DefaultLayout> } />
            <Route path="/unmanaged-linux-vps" element={ <DefaultLayout> <UnmanagedLinuxVPS /> </DefaultLayout> } />
            <Route path="/dedicated-server-new-york" element={ <DefaultLayout> <DedicatedServerNewYork /> </DefaultLayout> } />
            <Route path="/dedicated-server-los-angeles" element={ <DefaultLayout> <DedicatedServerLosAngeles /> </DefaultLayout> } />
            <Route path="/dedicated-server-montreal" element={ <DefaultLayout> <DedicatedServerMontreal /> </DefaultLayout> } />
            <Route path="/dedicated-server-brazil" element={ <DefaultLayout> <DedicatedServerBrazil /> </DefaultLayout> } />
            <Route path="/dedicated-server-germany" element={ <DefaultLayout> <DedicatedServerGermany /> </DefaultLayout> } />
            <Route path="/dedicated-server-india" element={ <DefaultLayout> <DedicatedServerIndia /> </DefaultLayout> } />
            <Route path="/dedicated-server-singapore" element={ <DefaultLayout> <DedicatedServerSingapore /> </DefaultLayout> } />
            <Route path="/dedicated-server-uae" element={ <DefaultLayout> <DedicatedServerUAE /> </DefaultLayout> } />
            <Route path="/streaming-server" element={ <DefaultLayout> <StreamingServers /> </DefaultLayout> } />
            <Route path="/live-streaming-vod" element={ <DefaultLayout> <LiveStreamingVOD /> </DefaultLayout> } />
            <Route path="/streaming-server-new-york" element={ <DefaultLayout> <StreamingServerNewYork /> </DefaultLayout> } />
            <Route path="/streaming-server-los-angeles" element={ <DefaultLayout> <StreamingServerLosAngeles /> </DefaultLayout> } />
            <Route path="/streaming-server-montreal" element={ <DefaultLayout> <StreamingServerMontreal /> </DefaultLayout> } />
            <Route path="/streaming-server-london" element={ <DefaultLayout> <StreamingServerLondon /> </DefaultLayout> } />
            <Route path="/office-365" element={ <DefaultLayout> <Office365 /> </DefaultLayout> } />
            <Route path="/cyber-security" element={ <DefaultLayout> <CyberSecurity /> </DefaultLayout> } />
            <Route path="/zimbra-mail-server" element={ <DefaultLayout> <Zimbra /> </DefaultLayout> } />
            <Route path="/ssl-certificate" element={ <DefaultLayout> <SSL /> </DefaultLayout> } />
            <Route path="/gpu-dedicated-server-germany" element={ <DefaultLayout> <GPUDedicatedServerGermany /> </DefaultLayout> } />
            <Route path="/gpu-dedicated-server-uk" element={ <DefaultLayout> <GPUDedicatedServerUK /> </DefaultLayout> } />
            <Route path="/gpu-dedicated-server-france" element={ <DefaultLayout> <GPUDedicatedServerFrance /> </DefaultLayout> } />
            <Route path="/gpu-dedicated-server-netherlands" element={ <DefaultLayout> <GPUDedicatedServerNetherlands /> </DefaultLayout> } />
            <Route path="/gpu-dedicated-server-sweden" element={ <DefaultLayout> <GPUDedicatedServerSweden /> </DefaultLayout> } />
            <Route path="/gpu-dedicated-server-switzerland" element={ <DefaultLayout> <GPUDedicatedServerSwitzerland /> </DefaultLayout> } />
            <Route path="/gpu-dedicated-server-ireland" element={ <DefaultLayout> <GPUDedicatedServerIreland /> </DefaultLayout> } />
            <Route path="/gpu-cloud-server-india" element={ <DefaultLayout> <GPUCloudServerIndia /> </DefaultLayout> } />
            <Route path="/gpu-dedicated-server-usa" element={ <DefaultLayout> <GPUDedicatedServerUSA /> </DefaultLayout> } />
            <Route path="/server-management" element={ <DefaultLayout> <ServerManagement /> </DefaultLayout> } />
            <Route path="/website-development" element={ <DefaultLayout> <WebDevelopment /> </DefaultLayout> } />
            <Route path="/app-development" element={ <DefaultLayout> <AppDevelopment /> </DefaultLayout> } />
            <Route path="/digital-marketing" element={ <DefaultLayout> <DigitalMarkeing /> </DefaultLayout> } />
            <Route path="/ai-chatbot" element={ <DefaultLayout> <AiChatbot /> </DefaultLayout> } />
            <Route path="/rag" element={ <DefaultLayout> <RAG /> </DefaultLayout> } />
            <Route path="/ai-software-services" element={ <DefaultLayout> <AiSoftwareService /> </DefaultLayout> } />
            <Route path="/backup-solutions" element={ <DefaultLayout> <BackupSolutions /> </DefaultLayout> } />
            <Route path="/our-team" element={ <DefaultLayout> <OurTeam /> </DefaultLayout> } />
            <Route path="/deals" element={ <DefaultLayout> <Deals /> </DefaultLayout> } />
            <Route path="/awards-and-recognitions" element={ <DefaultLayout> <AwardsAndRecognitions /> </DefaultLayout> } />
            <Route path="/certificates" element={ <DefaultLayout> <Certificate /> </DefaultLayout> } />
            <Route path="/work-culture" element={ <DefaultLayout> <WorkCulture /> </DefaultLayout> } />
            <Route path="/aws-cloud-hosting" element={ <DefaultLayout> <AWS /> </DefaultLayout> } />
            <Route path="/azure" element={ <DefaultLayout> <Azure /> </DefaultLayout> } />
            <Route path="/google-cloud" element={ <DefaultLayout> <GoogleCloud /> </DefaultLayout> } />
            <Route path="/kubernetes" element={ <DefaultLayout> <Kubernetes /> </DefaultLayout> } />
            <Route path="/odoo-server" element={ <DefaultLayout> <Odoo /> </DefaultLayout> } />
            <Route path="/vtiger-solutions" element={ <DefaultLayout> <VtigerSolutions /> </DefaultLayout> } />
            <Route path="/payment-options" element={ <DefaultLayout> <PaymentOptions /> </DefaultLayout> } />
            <Route path="/sitemap" element={ <DefaultLayout> <SiteMap /> </DefaultLayout> } />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </CurrencyProvider>
        </main>
      </div>
    </>
  );
}

export default App;
